Vue.component("TkCard", {


    props: {
        card: Object,

        turnable: {
            type: Boolean,
            default: function () {
                return true
            }
        }
    },

    template: `
        <div class="TkCard" :class="{'turn': turn}" @click="onClick">
            <div class="TkCard-innerWrapper">
                <div class="front">
                    <div class="content" >
                       <slot name="front"></slot>
                    </div>
                    <div class="btnRemove" @click="remove"></div>
                    <div class="btnTurn" v-if="turnable"></div>

                </div>
                <div class="back">
                     <div class="content">
                        <slot name="back"></slot>
                    </div>
                    <div class="btnRemove" @click="remove"></div>
                    <div class="btnTurn" v-if="turnable"></div>
                </div>
            </div>
        </div>
    `,
    data () {
        return {
            turn: false
        }
    },
    mounted () {
        this.events = {
            "turnable-cards-reset": () => {
                this.turn = false;
            }
        }
        app.radio.$on("turnable-cards-reset", this.events["turnable-cards-reset"]);

    },
    destroyed() {
        app.radio.$off("turnable-cards-reset", this.events["turnable-cards-reset"]);
    },
    methods: {
        remove () {
            this.$emit("remove", this.card.id);
        },
        onClick () {
            this.$emit("cardFlipped", this.card.id);
            this.$emit("click", this.card.id);
            this.turn = true;
        }
    }
})